import { ConsultationsHero } from '@/components/consultations/ConsultationsHero'
import { ConsultationsImageStrip } from '@/components/consultations/ConsultationsImageStrip'
import { ConsultationsOverview } from '@/components/consultations/ConsultationsOverview'
import { HowItWorksSection } from '@/components/consultations/HowItWorksSection'
import { ConsultationsTestimonial } from '@/components/consultations/ConsultationsTestimonial'

export const ConsultationsPage = () => (
  <>
    <ConsultationsHero />
    <ConsultationsImageStrip />
    <ConsultationsOverview />
    <HowItWorksSection />
    <ConsultationsTestimonial />
  </>
)
